import 'css-chunksrc/client/pages/zonePage/reportsPage/loader/styles.scss';export default {
  "reportsPage": "_reportsPage_ljovl_1",
  "main": "_main_ljovl_6",
  "section": "_section_ljovl_13",
  "title": "_title_ljovl_21",
  "reportsList": "_reportsList_ljovl_27",
  "report": "_report_ljovl_1"
};